import { render, staticRenderFns } from "./EmissionCategories.vue?vue&type=template&id=b64c568a"
import script from "./EmissionCategories.vue?vue&type=script&lang=js"
export * from "./EmissionCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports